import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ChatStatus } from './teams-chat.model';

@Injectable({
  providedIn: 'root'
})
export class TeamsChatService {
  private readonly baseUrl = '/TeamsChat';

  constructor(private http: HttpClient) {}

  /**
   * Get bot operators for a channel
   */
  getBotOperators(channelId: string, serviceChannelId?: string): Observable<any[]> {
    const params = serviceChannelId ? `?serviceChannelId=${encodeURIComponent(serviceChannelId)}` : '';
    return this.http.get<any[]>(`${this.baseUrl}/${channelId}/operators${params}`);
  }

  getConversations(channelId: string, audienceId: string, serviceChannelId?: string): Observable<any[]> {
    const params = serviceChannelId ? `?serviceChannelId=${encodeURIComponent(serviceChannelId)}` : '';
    return this.http.get<any[]>(`${this.baseUrl}/${channelId}/${audienceId}/conversations${params}`);
  }

  getWorkQueue(channelId: string, audienceId: string, serviceChannelId?: string): Observable<any[]> {
    const params = serviceChannelId ? `?serviceChannelId=${encodeURIComponent(serviceChannelId)}` : '';
    return this.http.get<any[]>(`${this.baseUrl}/${channelId}/${audienceId}/workqueue${params}`);
  }

  /**
   * Get bot for a channel
   */
  getBot(channelId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${channelId}/bot`);
  }

  /**
   * Post status update
   */
  updateOperatorStatus(channelId: string, audience: string, status: ChatStatus): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${channelId}/${audience}/status`, status);
  }

  /**
   * Get audience for a bot
   */
  getAudience(botId: string, audienceId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${botId}/audience/${audienceId}`);
  }

  /**
   * Join a conversation
   */
  joinConversation(channelId: string, conversationId: string, operatorAudienceId: string): Observable<any> {
    const url = `${this.baseUrl}/${channelId}/conversation/${conversationId}/join`;
    return this.http.post<any>(url, { operatorAudienceId });
  }

  /**
   * Get transcript for a conversation
   * Requires channelId and audienceId for operator validation
   */
  getTranscript(channelId: string, audienceId: string, conversationId: string): Observable<{ success: boolean; transcript: string }> {
    return this.http.get<{ success: boolean; transcript: string }>(
      `${this.baseUrl}/${channelId}/${audienceId}/conversation/${conversationId}/transcript`
    );
  }
}
